import { factory } from '@store/utils'

export default {
  auto: '*',
  store: {
    getters: {
      getFileExtension: (_, { fileExtensions }) => ({ extension }) =>
        fileExtensions[extension] || fileExtensions.etc,

      getFileUrl: () => ({ host, url }) => `https://${host}/${url}`,

      fileExtensions: () => ({
        csv: { theme: 'success', icon: 'file' },
        docx: { theme: 'info', icon: 'file' },
        pdf: { theme: 'danger', icon: 'file' },
      }),

      fileFactory: factory(({ authUser }) => ({
        authorUserId: null,
        extension: null,
        height: null,
        host: null,
        mime: null,
        name: null,
        label: null,
        size: null,
        type: null,
        url: null,
        userId: authUser.id,
        tags: [],
        width: null,
      })),
    },
  },
}
